import { Injectable } from '@angular/core';
import { AuthMFSDK } from 'authentification-multifacteur-sdk-js';
import { FeatureToggleService } from '../../core/services/feature-toggle.service';
import { BffCommunicationService } from '../../core/services/_index';
import { MPM_SECURITY_OTP } from '../../../configs/toggles.config';
import { Meta } from '@angular/platform-browser';
import { AppConfigService } from '../.././app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthMfService {
  private readonly ID_CONSOMMATEUR = 'c4cc829c-50f5-46dc-b1db-8c1cafe55817';
  private readonly ID_TRANSACTION = 'dbcfaf39-6435-4436-88bb-f44dd8b6c7b6';

  constructor(
    private readonly _featureToggleService: FeatureToggleService,
    private readonly _bffApiService: BffCommunicationService,
    private readonly _meta: Meta,
    private readonly _appConfigService: AppConfigService
  ) {}

  async authenticateTransaction() {
    let token = '';

    if (this._featureToggleService.hasFeatures(MPM_SECURITY_OTP.On)) {
      const authMfSDK = new AuthMFSDK(this.ID_CONSOMMATEUR);
      await authMfSDK.ready();
      token = await authMfSDK.getToken(this.ID_TRANSACTION);
    }

    await this._bffApiService.fetchAndSetMpmJwtForHeader(token);
  }
}
